import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: {
        costTags: '',
        costTagsCategory: '',
        costTagsResourceId: '',
        tags: ''
    },
    availableTags: [],
    dailyTagValues: [],
    tagValues: [],
    treeData: [],
    tags: []
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
